import { useTranslation } from 'react-i18next';

import { ButtonClearFilters } from '@/ui-kit/table-filters/ButtonClearFilter';
import { FormFilters } from '@/ui-kit/table-filters/FormFilters';
import { parseBasesPeriod, PeriodFilter } from '@/ui-kit/table-filters/PeriodFilter';
import { SearchFilter } from '@/ui-kit/table-filters/SearchFilter';
import { CheckFilter } from '@/ui-kit/table-filters/CheckFilter';

import { TCardTransactionFilterFields } from '@/store/types/card-transactions.type';
import { parseBasesRange, RangeFilter } from '@/ui-kit/table-filters/RangeFilter';
import { LookupFilter } from '@/ui-kit/table-filters/LookupFilter';

export interface ICardsTransactionFilterProps {
  fields: TCardTransactionFilterFields;
  clearFunction?: () => void;
}

export function CardTransactionsFilters({ fields, clearFunction }: ICardsTransactionFilterProps) {
  const { t } = useTranslation();

  return (
    <FormFilters data-testid="cardTransactions-filters" className="!my-0 max-w-[100%] flex flex-wrap">
      {fields?.search && (
        <SearchFilter
          value={fields.search.value}
          options={fields.search.options}
          onChange={fields.search.handleChange}
          placeholder={t('components.molecules.search.placeholder')}
        />
      )}
      {fields?.createdDate && (
        <PeriodFilter
          field={fields.createdDate}
          label={t('components.filters.date.date')}
          selectBase={parseBasesPeriod(t)}
          dateformat="iso"
          canSelectTime
        />
      )}
      {fields?.amount && (
        <RangeFilter
          field={fields.amount}
          label={t('components.filters.amount.title')}
          selectBase={parseBasesRange(t)}
        />
      )}
      {fields?.status && (
        <CheckFilter
          field={fields.status}
          label={t('pages.currentProfiles.cards.transactions.table.headers.paymentStatus')}
        />
      )}
      {fields?.mcc && (
        <LookupFilter field={fields.mcc} label={t('pages.currentProfiles.cards.transactions.table.headers.mcc')} />
      )}
      {fields?.mid && (
        <LookupFilter field={fields.mid} label={t('pages.currentProfiles.cards.settings.restrictions.commons.mid')} />
      )}
      {fields?.paymentTypes && (
        <CheckFilter
          field={fields.paymentTypes}
          label={t('pages.currentProfiles.cards.filters.payment.paymentFilters')}
        />
      )}

      {!!clearFunction ? <ButtonClearFilters onClick={clearFunction} /> : <></>}
    </FormFilters>
  );
}
